import { API } from '@api/api'
import { queryKeys } from '@api/queryKeys'
import type { LoadAdjustmentsControllerSyncMeasureSimulationData } from '@api/types/procurement'
import { skipToken, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { invalidateLoadPlanningAdjustmentQueries } from '../../load-planning/load-planning-adjustments/hooks/AdjustmentMutation.hooks'

interface MeasureSimulationCandidatesData {
  companyId?: number
  isMeasureSimulationEnabled: boolean
}

export const useFetchMeasureSimulationCandidates = (data: MeasureSimulationCandidatesData) =>
  useQuery({
    queryKey: queryKeys.procurement.measureSimulation.fetchCandidates.toKeyWithArgs(data.companyId),
    queryFn:
      data.companyId && data.isMeasureSimulationEnabled
        ? () => API.procurements.fetchMeasureSimulationCandidates({ companyId: data.companyId! })
        : skipToken,
  })

export const useSyncMeasureSimulationAsAdjustment = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: LoadAdjustmentsControllerSyncMeasureSimulationData) => {
      return API.procurements.syncMeasureSimulationAsAdjustment(data)
    },
    onSuccess: () => {
      invalidateLoadPlanningAdjustmentQueries(queryClient)
    },
  })
}
